import React from 'react';
import StartInterviewLayout from '../../components/layout/StartInterviewLayout';

const XML = () => {
  return (
    <StartInterviewLayout type="xml"/>
  )
}

export default XML;